import { ReactComponent as CopySvg } from '../../assets/copy.svg';

import { IconWrapper } from './iconWrapper';
import { IconProps } from './model';

export const CopyIcon = (props: IconProps) => {
    return (
        <IconWrapper {...props}>
            <CopySvg />
        </IconWrapper>
    );
};
